export const COOKIES_PREFERENCES_STORAGE_KEY = 'cookies_preferences';
export const COOKIE_CONSENT_STATUS_KEY = 'cookieconsent_status';

export interface CookiePreferences {
    analysis?: boolean;
    functionality?: boolean;
    advertising?: boolean;
    advertising2?: boolean;
}

export const ALL_DENIED_COOKIE_PREFERENCES: CookiePreferences = {
    analysis: false,
    functionality: false,
    advertising: false,
    advertising2: false,
};

export const ALL_GRANTED_COOKIE_PREFERENCES: CookiePreferences = {
    analysis: true,
    functionality: true,
    advertising: true,
    advertising2: true,
};
